var formRegex = /^(?![\s\S]*[,;'"][?=+\-@\t\r])[^?=+\-@\t\r][\s\S]+$/g;
export default formRegex;